module.exports = __webpack_public_path__ + "static/media/logo.c96cafd7.png";